import React from "react";
import "./CompanyHighlight.css";

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
    title: "Selenium Technology",
    desc: "Advanced selenium alloy plates deliver 30% longer cycle life and faster recharge compared to standard batteries.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: "Extreme Durability",
    desc: "Engineered to perform reliably in temperatures from -20°C to +50°C — built for India's harshest conditions.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="7" height="7" /><rect x="15" y="3" width="7" height="7" />
        <rect x="2" y="14" width="7" height="7" /><rect x="15" y="14" width="7" height="7" />
      </svg>
    ),
    title: "Complete Range",
    desc: "5 product categories — inverter, automotive, solar, tractor, and e-rickshaw — one brand for every need.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    ),
    title: "ISI Certified",
    desc: "Every battery meets Bureau of Indian Standards certification, backed by warranties of up to 5 years.",
  },
];

function CompanyHighlight() {
  return (
    <section className="company-highlight">
      <div className="highlight-container">

        <div className="highlight-header">
          <span className="highlight-eyebrow">Why Choose Us</span>
          <h2 className="highlight-title">
            The Oster <span className="highlight-title-accent">Advantage</span>
          </h2>
          <p className="highlight-subtitle">
            Every battery we make is a promise — of quality, longevity, and
            performance that never lets you down.
          </p>
        </div>

        <div className="highlight-grid">
          {features.map((feature, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default CompanyHighlight;
